import React from 'react';
import Link from 'next/link';

import { Button } from 'components/common/Button';
import { ButtonWrapper } from './atoms/ButtonWrapper';

const ErrorBack = (): JSX.Element => {
    return (
        <div>
            <ButtonWrapper>
                <Link href="/">
                    <Button tabIndex={0}>Keer terug naar home</Button>
                </Link>
            </ButtonWrapper>
        </div>
    );
};

export default ErrorBack;
